export default {

  pc: {
    listener: require('./common/listener').default,
    user: require('./common/user').default,
    ui: require('./pc/ui').default
  },
  m: {
    listener: require('./common/listener').default,
    user: require('./common/user').default,
  }
  
}